<div class="k-d-flex k-justify-content-between k-my-5">
    <div class="k-d-flex k-align-items-start k-w-1/4">
        <div class="k-d-flex k-align-items-center k-w-full k-justify-content-between">
            <div><strong>School Year&nbsp;</strong></div>
            <div class="k-w-3/4 k-mx-4">
                <kendo-dropdownlist class="k-w-full" [disabled]="editing" size="large" [data]="schoolYearData"
                    textField="description" valueField="id" [(ngModel)]="schoolYear"
                    (valueChange)="initializeClassesData()" [valuePrimitive]="true">
                </kendo-dropdownlist>
            </div>
            <!-- <div class="k-w-3/4 ">
                  <button kendoButton themeColor="primary" size="medium" fillMode="solid" (click)="addAssignmentType()">
                    Add AssignmentType
                  </button>
                </div> -->
        </div>
    </div>
    <button kendoButton class="excel-btn k-h-10 !k-border-0"
        [disabled]="editing || !(canAddEditNewClass || canEditOperationalClasses)" (click)="editing = true">
        {{ editing ? "Editing Classes" : "Edit Classes" }}
    </button>
</div>
<div class="k-bg-white">
    <kendo-grid class="class-info-grid" [data]="filteredClassesData" [autoSize]="true" scrollable="none" [loading]="classesLoading"
        [rowClass]="rowCallback">
        <kendo-grid-column *ngIf="editing" headerClass="action-column" title="Actions" [width]="50">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <button kendoButton *ngIf="canAddEditNewClass" [svgIcon]="xIcon" title="Delete" size="large" fillMode="outline" [disabled]="isClassRowDisabled(dataItem)"
                    themeColor="error" (click)="deleteClass(rowIndex)"></button>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="programCode" title="Program Code*" [width]="100">
            <ng-template *ngIf="editing" kendoGridCellTemplate let-data>
                <kendo-dropdownlist class="k-w-full" textField="description" valueField="id" size="large"
                    [disabled]="!canAddEditNewClass || isClassRowDisabled(data)" [data]="referenceData?.programCode" [(ngModel)]="data.programCode"
                    (blur)="markTouched(data, 'programCode')" (valueChange)="onProgramCodeChange($event, data)">
                </kendo-dropdownlist>
                <kendo-formerror *ngIf="showError(data, 'programCode')">
                    Error: Field is required
                </kendo-formerror>
            </ng-template>
            <ng-template *ngIf="!editing" kendoGridCellTemplate let-data>
                {{ data.programCode?.description }}
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="classType" title="Class Type*" [width]="120" [autoSize]="true">
            <ng-template *ngIf="!editing" kendoGridCellTemplate let-data>
                <div class="k-d-flex k-align-items-center">
                    <div>
                        {{ data.classType?.description }}
                    </div>
                    <div class="k-d-flex k-ml-2">
                        <kendo-badge *ngIf="data.twoMonth && data.tenMonth"
                            class="!k-pos-relative !k-translate-0 !k-z-0 twelve-month-badge" rounded="small"
                            size="large">
                            12 months
                        </kendo-badge>
                        <kendo-badge *ngIf="data.twoMonth && !data.tenMonth"
                            class="!k-pos-relative !k-translate-0 !k-z-0 two-month-badge" rounded="small" size="large">
                            2 months
                        </kendo-badge>
                        <kendo-badge *ngIf="data.tenMonth && !data.twoMonth"
                            class="!k-pos-relative !k-translate-0 !k-z-0 ten-month-badge" rounded="small" size="large">
                            10 months
                        </kendo-badge>
                        <kendo-badge *ngIf="data.required"
                            class="!k-pos-relative !k-translate-0 !k-z-0 action-required-badge" rounded="small"
                            size="large">
                            Action Required
                        </kendo-badge>
                    </div>
                </div>
            </ng-template>
            <ng-template *ngIf="editing" kendoGridCellTemplate let-data>
                <div>
                    {{ data.classType?.description }}
                </div>
                <!-- <kendo-dropdownlist *ngIf="data.placedCount === 0 || !data.classSk" class="k-w-full"
                    textField="description" valueField="id" size="large" [data]="referenceData?.classType"
                    [(ngModel)]="data.classType">
                  </kendo-dropdownlist> -->
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="specializedProgram" title="Specialized Program" [width]="100">
            <ng-template kendoGridHeaderTemplate>
                      <div class="k-white-space-normal">
                        Specialized Program
                      </div>
                    </ng-template>
            <ng-template *ngIf="editing" kendoGridCellTemplate let-data>
                <kendo-dropdownlist class="k-w-full" textField="value" valueField="id" size="large"
                    [data]="referenceData?.specializedProgram" [(ngModel)]="data.specializedProgram" [disabled]="!canAddEditNewClass || isClassRowDisabled(data)">
                </kendo-dropdownlist>
            </ng-template>
            <ng-template *ngIf="!editing" kendoGridCellTemplate let-data>
                {{ data.specializedProgram?.value }}
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="overallRatio" title="Overall Ratio*" [width]="100">
            <ng-template *ngIf="editing" kendoGridCellTemplate let-data>
                <kendo-dropdownlist *ngIf="data.classType?.id === scisClassTypeId" class="k-w-full"
                    textField="description" valueField="id" size="large" [data]="referenceData?.overallRatio"
                    (blur)="markTouched(data, 'overallRatio')" [(ngModel)]="data.overallRatio" [disabled]="!canAddEditNewClass || isClassRowDisabled(data)">
                </kendo-dropdownlist>
                <kendo-formerror *ngIf="
                        data.classType?.id === scisClassTypeId &&
                        showError(data, 'overallRatio')
                      ">
                    Error: Field is required
                </kendo-formerror>
            </ng-template>
            <ng-template kendoGridCellTemplate let-data>
                <ng-container *ngIf="!editing && data.classType?.id === scisClassTypeId">
                    {{
                    data.classType?.id === scisClassTypeId
                    ? data.overallRatio?.description
                    : ""
                    }}
                </ng-container>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="seRatio" title="SE Ratio*" [width]="100">
            <ng-template *ngIf="editing" kendoGridCellTemplate let-data>
                <kendo-dropdownlist *ngIf="data.classType?.id === specialClassTypeId" class="k-w-full" textField="description" valueField="id" size="large"
                    (blur)="markTouched(data, 'seRatio')" [data]="referenceData?.seRatio" [(ngModel)]="data.seRatio" [disabled]="!canAddEditNewClass || isClassRowDisabled(data)">
                </kendo-dropdownlist>
                <kendo-formerror *ngIf="
                        data.classType?.id === specialClassTypeId &&
                        showError(data, 'seRatio')
                      ">
                    Error: Field is required
                </kendo-formerror>
            </ng-template>
            <ng-template kendoGridCellTemplate let-data>
                <ng-container *ngIf="!editing && data.classType?.id === specialClassTypeId">
                    {{ data.seRatio?.description }}
                </ng-container>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="language" title="Language*" [width]="100">
            <ng-template *ngIf="editing" kendoGridCellTemplate let-data>
                <kendo-dropdownlist class="k-w-full" textField="description" valueField="id" size="large"
                    (blur)="markTouched(data, 'language')" [data]="referenceData?.language" [(ngModel)]="data.language" [disabled]="!canAddEditNewClass || isClassRowDisabled(data)">
                </kendo-dropdownlist>
                <kendo-formerror *ngIf="showError(data, 'language')">
                    Error: Field is required
                </kendo-formerror>
            </ng-template>
            <ng-template *ngIf="!editing" kendoGridCellTemplate let-data>
                {{ data.language?.description }}
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="dayLength" title="Day Length*" [width]="100">
            <ng-template *ngIf="editing" kendoGridCellTemplate let-data>
                <kendo-dropdownlist class="k-w-full" textField="description" valueField="id" size="large"
                    (blur)="markTouched(data, 'dayLength')" [data]="referenceData?.dayType" [(ngModel)]="data.dayLength" [disabled]="!canAddEditNewClass || isClassRowDisabled(data)">
                </kendo-dropdownlist>
                <kendo-formerror *ngIf="showError(data, 'dayLength')">
                    Error: Field is required
                </kendo-formerror>
            </ng-template>
            <ng-template *ngIf="!editing" kendoGridCellTemplate let-data>
                {{ data.dayLength?.description }}
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="authorized" title="Authorized*" [width]="100">
            <ng-template *ngIf="editing" kendoGridCellTemplate let-data>
                <kendo-numerictextbox [min]="0" [max]="100" format="##" [(ngModel)]="data.authorized"
                    (blur)="markTouched(data, 'authorized')" [disabled]="!canAddEditNewClass || isClassRowDisabled(data)">
                </kendo-numerictextbox>
                <kendo-formerror *ngIf="showError(data, 'authorized')">
                    Error: Field is required
                </kendo-formerror>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="operational" title="Operational*" [width]="100">
            <ng-template *ngIf="editing" kendoGridCellTemplate let-data>
                <kendo-numerictextbox [min]="0" [max]="data.authorized" format="##" [(ngModel)]="data.operational"
                    (blur)="markTouched(data, 'operational')" [disabled]="!canEditOperationalClasses || isClassRowDisabled(data)">
                </kendo-numerictextbox>
                <kendo-formerror *ngIf="showError(data, 'operational')">
                    Error: Field is required
                </kendo-formerror>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column *ngIf="editing" title="10 Month" [width]="100">
            <ng-template kendoGridCellTemplate let-data>
                <input type="checkbox" size="medium" kendoCheckBox [(ngModel)]="data.tenMonth" [disabled]="!canAddEditNewClass || isClassRowDisabled(data)" />
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column *ngIf="editing" title="2 Month" [width]="100">
            <ng-template kendoGridCellTemplate let-data>
                <input type="checkbox" size="medium" kendoCheckBox [(ngModel)]="data.twoMonth" [disabled]="!canAddEditNewClass || isClassRowDisabled(data)" />
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column *ngIf="!editing" headerClass="action-column" title="Actions" [width]="100">
            <ng-template kendoGridCellTemplate let-data>
                <button *ngIf="showView(data)" kendoButton themeColor="primary" fillMode="outline"
                    (click)="navigateToClass(data)">
                    View
                </button>
            </ng-template>
        </kendo-grid-column>
        <ng-template kendoGridNoRecordsTemplate>
            <div class="k-d-flex k-justify-content-center k-align-items-center k-h-30">
                No classes to display. To add classes, click the "Edit Classes" button above.
            </div>
        </ng-template>
    </kendo-grid>
    <div *ngIf="editing" class="k-d-flex k-px-4 k-py-4">
        <button kendoButton *ngIf="canAddEditNewClass" [svgIcon]="plusIcon" themeColor="primary" fillMode="outline"
            (click)="addEmptyRow()">
            Add Empty Row
        </button>
        <button kendoButton *ngIf="canAddEditNewClass" [disabled]="canEdit" [svgIcon]="copyIcon" class="k-ml-4" themeColor="primary" fillMode="outline"
            (click)="duplicateLastRow()">
            Duplicate Last Row
        </button>
    </div>
    <div *ngIf="editing" class="k-d-flex k-justify-content-between k-px-6 k-py-4 action-btn">
        <button kendoButton themeColor="error" fillMode="outline" (click)="cancel()">
            Cancel
        </button>
        <button kendoButton themeColor="primary" (click)="openDialog(true)">
            Save
        </button>
    </div>
    <div kendoDialogContainer></div>
</div>

<kendo-dialog *ngIf="showSavePopUp" [maxWidth]="1900" [width]="600" [minHeight]="200">
    <h4 class="k-w-full heading-cls" >
        Apply changes to the Upcoming School Year?
    </h4>
    <div class="dialog-body">
        <p>You are saving changes to the Current School Year ({{ schoolYear }}). Choose whether these changes should also carry forward into the Upcoming School Year ({{ getUpcomingSchoolYear() }}).</p>
    </div>
    <kendo-dialog-actions>
        <div class="k-mt-2 k-text-right margin">
            <div class="action-btns   footer">
                <div class="action-btns__right">
                    <button kendoButton size="large" rounded="large" fillMode="outline" themeColor="error"
                        (click)="onCloseDialog()">
                        Cancel
                    </button>
                    <button kendoButton size="large" rounded="large" 
                         fillMode="outline" themeColor="primary" (click)="saveCurrentSY()">
                        Current SY only
                    </button>
                    <button kendoButton size="large" rounded="large" 
                         fillMode="solid" themeColor="primary" (click)="saveCurrentSYAndNextSY()">
                        Apply to both
                    </button>
                </div>
            </div>
        </div>
    </kendo-dialog-actions>
</kendo-dialog>